import React, { useEffect, useState } from 'react';
import axios from 'axios';
import BASE_URL from '../../../config/config';
import { jwtDecode } from 'jwt-decode';
import Popup from '../../../components/Popup';

const AdminTicketStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userRole, setUserRole] = useState('');
  const [popupOpen, setPopupOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('AuthToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserRole(decoded.role || '');
      } catch (err) {
        console.warn('Token decode failed', err);
      }
    }
    const fetchStats = async () => {
      setLoading(true);
      try {
        const resp = await axios.get(`${BASE_URL}/api/admin/stats/tickets`, {
          headers: { Authorization: token }
        });
        setStats(resp.data);
      } catch (err) {
        console.error('Error obteniendo estadísticas:', err);
        setError('No se pudieron cargar las estadísticas');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return <div className="admin-stats-grid admin-stats-status">Cargando estadísticas...</div>;
  }

  if (error || !stats) {
    return <div className="admin-stats-grid admin-stats-status">{error || 'Sin datos'}</div>;
  }

  return (
    <div>
      <div className="admin-stats-grid">
      <div className="prepanel-card stat-card">
        <div className="cabecera-prepanel-card">
          <h4>Tickets abiertos</h4>
        </div>
        <div>
          <p style={{fontSize:20, fontWeight:700}}>{stats.openTotal}</p>
          <p style={{marginTop:6, color:'#6b7280'}}>Hoy <span style={{fontWeight:700}}>{stats.openedToday >= 0 ? `+${stats.openedToday}` : stats.openedToday}</span></p>
        </div>
      </div>

      <div className="prepanel-card stat-card">
        <div className="cabecera-prepanel-card">
          <h4>Tiempo promedio de resolución</h4>
        </div>
        <div>
          <p style={{fontSize:16, fontWeight:700}}>{stats.avgResolutionTimeHuman || '—'}</p>
          {userRole === 'admin' && (
            <div style={{marginTop:8}}>
              <button className="boton-desglose-departamentos" onClick={() => setPopupOpen(true)}>Desglose por departamento</button>
            </div>
          )}
        </div>
      </div>

      <div className="prepanel-card stat-card">
        <div className="cabecera-prepanel-card">
          <h4>Tickets resueltos hoy</h4>
        </div>
        <div>
          <p style={{fontSize:20, fontWeight:700}}>{stats.resolvedToday}</p>
        </div>
      </div>

      <div className="prepanel-card stat-card">
        <div className="cabecera-prepanel-card">
          <h4>Tickets urgentes</h4>
        </div>
        <div>
          <p style={{fontSize:20, fontWeight:700}}>{stats.urgentOpenTotal}</p>
        </div>
      </div>
    </div>
      {/* Breakdown por departamento ahora sólo accesible vía popup para Admins */}

      <Popup open={popupOpen} title="Desglose por departamento" onClose={() => setPopupOpen(false)} cancelText="Cerrar">
        {stats.avgResolutionByDept && Object.keys(stats.avgResolutionByDept).length > 0 ? (
          <div className="desglose-departamentos">
            {Object.entries(stats.avgResolutionByDept).map(([dept, data]) => {
              // Formateador: mapea slugs comunes a nombres legibles
              const formatSingleDept = (slug) => {
                if (!slug) return 'Sin asignar';
                const map = {
                  desarrollo: 'Dpto. Desarrollo',
                  diseno: 'Dpto. Diseño',
                  soporte: 'Dpto. Soporte',
                  infraestructura: 'Dpto. Infraestructura',
                  ventas: 'Dpto. Ventas',
                  administracion: 'Dpto. Administración',
                  no_asignado: 'Sin asignar'
                };
                if (map[slug]) return map[slug];
                // Fallback: capitalizar palabras y prefijar
                const words = String(slug).replace(/[_\-]+/g, ' ').split(' ').filter(Boolean).map(w => w.charAt(0).toUpperCase() + w.slice(1));
                return `Dpto. ${words.join(' ')}`;
              };

              const isInterv = dept.startsWith('intervencion_');
              let displayName;
              if (isInterv) {
                const inner = dept.replace('intervencion_', '') || 'no_asignado';
                displayName = `Intervención en ${formatSingleDept(inner)}`;
              } else {
                displayName = formatSingleDept(dept);
              }

              return (
                <div key={dept} className="fila-departamento">
                  <div className="departamento-izq">
                    <div className="nombre-departamento">{displayName}</div>
                    <div className="conteo-departamento">Tickets: {data.count}</div>
                  </div>
                  <div className="departamento-der">
                    <div className="tiempo-departamento">{data.avgResolutionTimeHuman}</div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div>No hay datos por departamento.</div>
        )}
      </Popup>
    </div>
  );
};

export default AdminTicketStats;
